import styled from 'styled-components/macro';

const RangeSlider = styled.div`
  position: relative;
  height: 6px;
  margin: 20px 0;
  border-radius: 3px;
  background-image:
    repeating-linear-gradient(
      90deg,
      transparent,
      transparent 20%,
      #000 20%,
      #000 calc(20% + 1px)
    ),
    linear-gradient(to left, #58f9a1, #fb9660 49%, #fd1e68);
  touch-action: none;
`;

export default RangeSlider;
